<div class="mm-dialog" *ngIf="attribute"
     [mmTestId]="'PRODUCT_CATALOG.FILTER_MODAL'">
  <div class="mm-dialog__header">
    <h2 class="mm-dialog__title">{{ attribute?.name }}</h2>
    <div class="mm-dialog__close"
         [mmTestTarget]="'attribute-modal-close-button'"
         (click)="onClose()">
      <mm-icon name="close" class="modal-close-icon"></mm-icon>
    </div>
  </div>
  <div class="mm-dialog__content">
    <div class="attribute-list__modal-search">
      <mm-field class="attribute-list__modal-input">
        <input
          mmInput
          type="text"
          [placeholder]="searchInputPlaceHolder | translate"
          [formControl]="optionSearchFormControl">
      </mm-field>
      <app-svg-search class="icon--search" (click)="searchAttributes()">
      </app-svg-search>
      <mm-icon *ngIf="optionSearchFormControl?.value" class="attribute-list-clear__icon" name="close"
               (click)="clearAttributeSearch()">
      </mm-icon>
    </div>
    <div class="attribute-list__modal" fxLayout="row" fxLayoutAlign="space-between start">
      <ng-container *ngIf="!searchLoading; else loading">
        <ng-container *ngIf="list?.length; else noresults">
          <ul class="attribute__list">
            <li *ngFor="let letterOptions of list">
              <span class="attributes__list-key"> {{ letterOptions.key }} </span>
              <ng-container *ngFor="let option of letterOptions?.options">
                <ng-container *ngTemplateOutlet="attributeOptionContent; context: { option: option }"></ng-container>
              </ng-container>
            </li>
          </ul>
        </ng-container>
        <ng-template #noresults>
          <div class="attributes__list-no-results">
            <p class="attributes__list-no-results-title">
              {{ 'FILTERS.MODAL.SEARCH.NOT_FOUND.TITLE' | translate }}
            </p>
            <p class="attributes__list-no-results-text">
              {{ 'FILTERS.MODAL.SEARCH.NOT_FOUND.TEXT' | translate }}
            </p>
          </div>
        </ng-template>
      </ng-container>
      <ng-template #loading>
        <mm-spinner diameter="50"></mm-spinner>
      </ng-template>
    </div>
  </div>

  <ng-template #attributeOptionContent let-option="option">
    <label class="attribute-list-item">
      <mm-checkbox [mmTestTarget]="'attribute-modal-filter'"
                   labelType="short"
                   [checked]="selectedOptions[attribute?.id + '--' + option?.value]"
                   (change)="onOptionToggle(option, $event)">
        {{option?.name}}
      </mm-checkbox>
      <div class="attribute-list-item__count">{{option?.totalCount}}</div>
    </label>
  </ng-template>

  <div class="mm-dialog__footer" fxLayout="row" fxLayoutAlign="end center">
    <div *ngIf="isMobileOrTablet && isSpecificAttribute" class="attribute-modal__apply-button-container">
      <button
        class="attribute-modal__apply-button"
        mm-button
        [mmTestTarget]="'attribute-modal-apply-button'"
        (click)="onShowResults()">
        {{ 'CATALOG.CATALOG_PAGE.FILTERS.BUTTON.SHOW' | translate: {count: productsTotalCount$ | async} }}
      </button>
    </div>
    <button *ngIf="isMobileOrTablet && !isSpecificAttribute"
            class="attribute-modal__apply-button"
            mm-button
            [mmTestTarget]="'attribute-modal-apply-button'"
            (click)="onFiltersApplied()">
      {{'FILTERS.MODAL.SEARCH.DONE' | translate}}
    </button>
    <button *ngIf="!isMobileOrTablet"
            class="attribute-modal__apply-button"
            mm-button
            [mmTestTarget]="'attribute-modal-apply-button'"
            (click)="onFiltersApplied()">
      {{'FILTERS.MODAL.APPLY' | translate}}
    </button>

  </div>
</div>
